const CONTROL_ORGANIZATION_KEY = 'flow';

export default CONTROL_ORGANIZATION_KEY;
